/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AddNoteHistory.vue?vue&type=template&id=22355e2d"
import script from "./AddNoteHistory.vue?vue&type=script&lang=js"
export * from "./AddNoteHistory.vue?vue&type=script&lang=js"
import style0 from "./AddNoteHistory.vue?vue&type=style&index=0&id=22355e2d&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22355e2d')) {
      api.createRecord('22355e2d', component.options)
    } else {
      api.reload('22355e2d', component.options)
    }
    module.hot.accept("./AddNoteHistory.vue?vue&type=template&id=22355e2d", function () {
      api.rerender('22355e2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/partials/AddNoteHistory.vue"
export default component.exports